export const login = (state = {}, action) => {
    switch (action.type) {
        case "LOGIN": {
            return { 
                apiKey: action.payload.apiKey, 
                userNumber: action.payload.userNumber, 
                loginUserInfo: action.payload.loginUserInfo, 
                memberInfo:action.payload.memberInfo,
                memberCode: action.payload.memberCode ,
                hashAutoLogin:action.payload.hashAutoLogin,
                userId:action.payload.userId,
                loginType:action.payload.loginType
            };
        }
        default: {
            return state;
        }
    }
};